import { FC, useEffect, useMemo, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { getTheme } from "Store/MultiDomain/MultiDomain.selector";
import { Icon } from "Components/UI";
import { Checkbox, ConfigProvider } from "antd";
import Button from "Components/UI/Button";
import { IRequestPlotColumns } from "Pages/ListagemArquivos/ListagemArquivos.columns";
import { Container, Counter } from "./styles";

interface ILotePlotagens {
  allFilesCount: number;
  selectedFiles: number[];
  fileList: IRequestPlotColumns[];
  onSubmit: (
    allQrCode: boolean,
    allColors: boolean,
    allCopysCount: number,
    selectedFiles?: number[],
  ) => void;
  onClose: () => void;
}

const LotePlotagens: FC<ILotePlotagens> = ({
  allFilesCount,
  selectedFiles,
  fileList,
  onSubmit,
  onClose,
}) => {
  const theme = useSelector(getTheme);

  const allQrCodeRef = useRef(false);
  const allColorsRef = useRef(false);
  const [allQrCode, setAllQrCode] = useState(false);
  const [allQrCodeIndeterminate, setAllQrCodeIndeterminate] = useState(false);
  const [allColors, setAllColors] = useState(false);
  const [allColorsIndeterminate, setAllColorsIndeterminate] = useState(false);
  const [allCopysCount, setAllCopysCount] = useState(0);

  const filteredFiles = useMemo(() => {
    if (selectedFiles?.length > 0) {
      return fileList.filter((f, i) => selectedFiles.includes(i));
    }
    return fileList;
  }, [fileList, selectedFiles]);

  const handleQrCode = (value: boolean) => {
    setAllQrCode(value);
    setAllQrCodeIndeterminate(false);
  };

  const handleColors = (value: boolean) => {
    setAllColors(value);
    setAllColorsIndeterminate(false);
  };

  const handleCounter = (value: number) => {
    setAllCopysCount(prev => {
      const newValue = prev + value;
      if (newValue < 0) return prev;
      return newValue;
    });
  };

  const handleSubmit = () => {
    const notSelecteds = selectedFiles.length === 0 ||
      selectedFiles.length === allFilesCount;

    onSubmit(
      allQrCode,
      allColors,
      allCopysCount,
      notSelecteds ? undefined : selectedFiles,
    );
    onClose();
  };

  useEffect(() => {
    if (filteredFiles) {
      const qrCode = filteredFiles.every(f => f.ShowQRCode);
      const colors = filteredFiles.every(f => f.HasColor);
      allQrCodeRef.current = qrCode;
      allColorsRef.current = colors;
      setAllQrCode(qrCode);
      setAllQrCodeIndeterminate(!qrCode && filteredFiles.some(f => f.ShowQRCode));
      setAllColors(colors);
      setAllColorsIndeterminate(!colors && filteredFiles.some(f => f.HasColor));
    }
  }, [filteredFiles]);

  const isBtnDisabled = (allQrCode === allQrCodeRef.current) &&
    (allColors === allColorsRef.current) &&
    (allQrCodeIndeterminate || allColorsIndeterminate) &&
    allCopysCount === 0;

  return (
    <Container>
      <div className="titleLote">
        <span className="textLote">
          {!!selectedFiles.length && (selectedFiles.length !== allFilesCount)
            ? 'Aplicar a selecionados'
            : 'Aplicar a todos'
          }
        </span>
      </div>

      <ConfigProvider theme={{
        token: {
          colorBgContainerDisabled: `color-mix(in srgb, ${theme.colors.primary.primaryOutline}, ${theme.colors.surface.surface})`,
          colorTextDisabled: theme.colors.primary.onPrimary,
          colorPrimary: theme.colors.primary.primary
        }
      }}>
        <div className="mainLote">
          <span className="mainLoteLeft">
            <Icon
              icon="qrCode"
              customSize={16}
              className="iconLote"
            />
            <span className="labelLote">QR Code</span>
          </span>
          <Checkbox
            name={`isQrCode`}
            checked={allQrCode}
            indeterminate={allQrCodeIndeterminate}
            onChange={e => handleQrCode(e.target.checked)}
          />
        </div>
        <div className="mainLote">
          <span className="mainLoteLeft">
            <Icon
              icon="palette"
              customSize={16}
              className="iconLote"
            />
            <span className="labelLote">Colorido</span>
          </span>
          <Checkbox
            name={`isQrCode`}
            checked={allColors}
            indeterminate={allColorsIndeterminate}
            onChange={e => handleColors(e.target.checked)}
          />
        </div>
        <div className="mainLote">
          <span className="mainLoteLeft">
            <Icon
              icon="copiar"
              customSize={16}
              className="iconLote"
            />
            <span className="labelLote">Cópias</span>
          </span>
          <Counter active={allCopysCount > 0}>
            <Icon
              icon="subtrair"
              className="iconCounter"
              onClick={() => handleCounter(-1)}
            />
            <span className="textCounter">{allCopysCount}</span>
            <Icon
              icon="adicionar"
              className="iconCounter"
              onClick={() => handleCounter(1)}
            />
          </Counter>
        </div>
      </ConfigProvider>

      <div className="footerLote">
        <Button
          type="primary"
          disabled={isBtnDisabled}
          className="btnLote"
          onClick={handleSubmit}
        >
          Aplicar
        </Button>
      </div>
    </Container>
  )
}

export default LotePlotagens;
